import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { PageHeader, StatCard, Card, Btn } from '../components/ui';
import { api } from '../lib/api';

interface Kpi {
  ordersToday: number;
  revenueToday: number;
  litersToday: number;
  pendingAuthFiles: number;
  pendingOrders: number;
  activeStations: number;
  surtidoToday?: number;
}

interface TransfersResp { total: number }

export default function DashboardPage() {
  const { data, isLoading } = useQuery<Kpi>({ queryKey: ['admin', 'kpis'], queryFn: () => api<Kpi>('/api/admin/kpis') });
  const { data: pendingTransfers } = useQuery<TransfersResp>({
    queryKey: ['admin', 'transfers', 'pending-count'],
    queryFn: () => api<TransfersResp>('/api/admin/bank-transfers', { query: { status: 'pending', limit: 1 } }),
  });

  return (
    <div>
      <PageHeader kicker="HOY" title="Operación en vivo" sub="Métricas del día y atajos a tareas pendientes." />

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16 }}>
        <StatCard label="Órdenes hoy" value={isLoading ? '…' : String(data?.ordersToday ?? 0)} />
        <StatCard label="Ingresos hoy" value={isLoading ? '…' : `$${(data?.revenueToday ?? 0).toFixed(2)}`} accent />
        <StatCard label="Litros surtidos" value={isLoading ? '…' : `${data?.litersToday ?? 0} L`} />
        <StatCard label="Surtidos hoy" value={isLoading ? '…' : String(data?.surtidoToday ?? 0)} />
        <StatCard label="Autorizos pendientes" value={isLoading ? '…' : String(data?.pendingAuthFiles ?? 0)} />
        <StatCard label="Estaciones activas" value={isLoading ? '…' : String(data?.activeStations ?? 0)} />
      </div>

      <div style={{ marginTop: 32, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 16 }}>
        <Card>
          <div className="mono" style={{ fontSize: 10, letterSpacing: '0.12em', color: 'var(--text-3)' }}>ACCIONES PENDIENTES</div>
          <div style={{ marginTop: 12, display: 'flex', flexDirection: 'column', gap: 8 }}>
            <Link to="/auth-files"><Btn>{data?.pendingAuthFiles ?? 0} autorizos a revisar</Btn></Link>
            <Link to="/transfers?status=pending"><Btn variant="ghost">{pendingTransfers?.total ?? 0} transferencias a conciliar</Btn></Link>
            <Link to="/orders?status=pending_payment"><Btn variant="ghost">Ver pagos pendientes</Btn></Link>
          </div>
        </Card>
        <Card>
          <div className="mono" style={{ fontSize: 10, letterSpacing: '0.12em', color: 'var(--text-3)' }}>OBSERVABILIDAD</div>
          <div style={{ marginTop: 12, display: 'flex', flexDirection: 'column', gap: 8 }}>
            <Link to="/cron-runs"><Btn variant="ghost">Ejecuciones de crons</Btn></Link>
          </div>
        </Card>
      </div>
    </div>
  );
}
